import React, { useEffect, useMemo, useState } from "react";
import { FiUsers, FiClipboard } from "react-icons/fi";
import useAuth from "../../../../../hooks/useAuth";
import CustomerManagement from "./CustomerManagement/CustomerManagement";
import RequirementManagement from "./RequirementManagement/RequirementManagement";
import "./CustomerService.css";

const normalizePermission = (value) => typeof value === "string" ? value.trim().toLowerCase() : String(value?.code || "").trim().toLowerCase();

const CustomerService = () => {
  const { permissions = [], permissionCodes = [], isOwner, user, role } = useAuth();
  const owner = Boolean(isOwner) || String(user?.userType || role?.code || "").toUpperCase() === "OWNER";
  const permissionSet = useMemo(() => new Set([...(Array.isArray(permissionCodes)?permissionCodes:[]), ...(Array.isArray(permissions)?permissions:[])].map(normalizePermission).filter(Boolean)), [permissionCodes, permissions]);
  const hasPermission = (code) => owner || permissionSet.has(String(code).toLowerCase());

  const canViewCustomers = hasPermission("customer.view");
  const canViewRequirements = hasPermission("requirement.view");

  const tabs = useMemo(() => [
    canViewCustomers ? { key:"customers", title:"All Customers", icon:<FiUsers /> } : null,
    canViewRequirements ? { key:"requirements", title:"Customer Requirements", icon:<FiClipboard /> } : null,
  ].filter(Boolean), [canViewCustomers, canViewRequirements]);

  const [activeTab, setActiveTab] = useState(() => tabs[0]?.key || "");
  useEffect(() => { if (!tabs.some(t => t.key === activeTab)) setActiveTab(tabs[0]?.key || ""); }, [tabs, activeTab]);

  if (!tabs.length) return <div className="customer-service-page"><div className="customer-service-content"><div className="customer-service-error">You do not have permission to view Customers or Customer Requirements.</div></div></div>;

  return <div className="customer-service-page">
    <div className="customer-service-header"><div><span className="customer-service-title-small">CUSTOMER SERVICE</span></div></div>
    <div className="customer-service-tabs">{tabs.map(tab => <button key={tab.key} className={`customer-service-tab ${activeTab===tab.key?"active":""}`} onClick={()=>setActiveTab(tab.key)}>{tab.icon}<span>{tab.title}</span></button>)}</div>
    <div className="customer-service-content">
      {activeTab === "customers" && canViewCustomers ? <CustomerManagement openRequirements={canViewRequirements ? ()=>setActiveTab("requirements") : undefined} /> : null}
      {activeTab === "requirements" && canViewRequirements ? <RequirementManagement openCustomers={canViewCustomers ? ()=>setActiveTab("customers") : undefined} /> : null}
    </div>
  </div>;
};

export default CustomerService;
